<template>
    <div class="i-map" :id="'map_2gis_'+mapId" :style="{height:height+'px'}">
    </div>
</template>
<script>
export default {

    name: 'i-map',

    data() {
        return {
            mapId: _.random(1, 2560)
        }
    },
    props: {
        coords: {
            type: Array,
            default () { return [51, 71] }
        },
        zoom: {
            type: Number,
            default: 13
        },
        height: {
            type: Number,
            default: 300
        }
    },
    mounted() {
        let { mapId, coords, zoom } = this;
        var script = document.createElement('script');
        script.onload = function() {
            DG.then(function() {
                let map = DG.map('map_2gis_' + mapId, {
                    'center': coords,
                    'zoom': zoom,
                    //geoclicker:false
                });
                DG.marker(coords).addTo(map);
            });
        };
        script.src = "https://maps.api.2gis.ru/2.0/loader.js?pkg=full&lazy=true";

        document.head.appendChild(script);
    }
}
</script>
<style lang="css" scoped>
.i-map {
    width: 100%;
}
</style>